import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 17l0 -14","key":"svg-0"}],["path",{"d":"M15 6l-3 -3l-3 3","key":"svg-1"}],["path",{"d":"M10 21v-4h4v4l-4 0","key":"svg-2"}]]

const IconArrowUpSquare = createReactComponent('outline', 'arrow-up-square', 'ArrowUpSquare', __iconNode);

export default IconArrowUpSquare;